import { ValidateJSModel, ValidateJSModelAttribute } from 'forms/shared/types';
import locationModelValidator from '../location';
import { LocationModel } from '../types';
import { getUSInclusionsByForm } from 'helpers/form';

interface LocationCityStateModel {
  city: LocationModel['city']
  state: LocationModel['state']
}

const locationCityStateModelValidator: ValidateJSModel<LocationCityStateModel> = {
  city: locationModelValidator.city as ValidateJSModelAttribute<LocationCityStateModel, 'city'>,
  state: (value, attributes, attributeName, options) => {
    return {
      presence: true,
      inclusion: getUSInclusionsByForm(options?.formType),
    };
  },
};

export default locationCityStateModelValidator;
